import React, { memo } from 'react';
import { addCommas } from '@persian-tools/persian-tools';
import styles from './RegionTitle.module.scss';
import Box from '@/components/UI/box/Box';
import Skeleton from '@/components/UI/skeleton/Skeleton';
import Typography from '@/components/UI/typography/Typography';
import { SearchDataProps } from '@/components/search/_types/searchDataType';
import { useRouter } from 'next/router';
const RegionTitle = ({
  data
}: {
  data: SearchDataProps;
}) => {
  const router = useRouter();
  const pageContentSet = {
    '/all-boomgardi': 'رزرو اقامتگاه بوم گردی',
    '/all-cottage': 'اجاره کلبه چوبی و جنگلی'
  };
  const h1 = pageContentSet[router.pathname] || 'اجاره ویلا و سوئیت';
  return <Box className={styles['region-title-container']} data-sentry-element="Box" data-sentry-component="RegionTitle" data-sentry-source-file="RegionTitle.tsx">
      {data?.loading ? <>
          <Skeleton width={150} />
          <Skeleton width={100} />
        </> : <>
          <Typography component="h1" variant="bodyL" color="neutral_900">
            {h1}
          </Typography>
          <Typography variant="bodyS" className={styles['house-count-text']}>
            {data?.pagination?.total ? ` (${addCommas(data?.pagination?.total)} اقامتگاه)` : ''}
          </Typography>
        </>}
    </Box>;
};
export default memo(RegionTitle);